import * as yup from "yup";
import { OrganizationTypesEnum } from "../../graphql/graphql";
import { cleanUrl } from "../../utils/Url.utils";
import { Length, Max, Min, Patterns, Validation } from "../../utils/Validation.utils";
export const OrganizationInitialValues = {
    name: "",
    npiNumber: "",
    email: "",
    phoneNumber: "",
    about: "",
    notes: "",
    insuranceIds: [],
    organizationTypes: [],
    websiteUrl: null,
    therapyCategoryIds: [],
    imageKey: null,
    imageVersion: null
};
export const OrganizationSchema = yup.object().shape({
    name: yup
        .string()
        .min(Min.Name, Validation.Min)
        .max(Max.Name, Validation.Max)
        .required(Validation.Required),
    npiNumber: yup.string().length(Length.NpiNumber, Validation.Length),
    email: yup.string().email(Validation.Invalid).required(Validation.Required),
    phoneNumber: yup
        .string()
        .matches(Patterns.PhoneNumber, Validation.Invalid)
        .max(Max.PhoneNumber, Validation.Max)
        .required(Validation.Required),
    about: yup.string(),
    notes: yup.string(),
    organizationTypes: yup
        .array()
        .of(yup
        .mixed()
        .oneOf(Object.values(OrganizationTypesEnum))
        .required(Validation.Required)),
    websiteUrl: yup
        .string()
        .transform((value) => cleanUrl(value))
        .url(Validation.Invalid)
        .nullable()
        .optional(),
    insuranceIds: yup.array().of(yup.string().required(Validation.Required)),
    therapyCategoryIds: yup
        .array()
        .of(yup.string().required(Validation.Required)),
    imageKey: yup.string().nullable(),
    imageVersion: yup.string().nullable()
});
